import { useState } from "react";
import { Link } from "react-router-dom";

const SUBJECTS = [
  "General Inquiry",
  "Event / Retreat Registration",
  "Volunteer Opportunities",
  "Donation & Tax Receipt",
  "Technical Support",
  "Media / Press",
  "Other",
];

const COUNTRY_CODES = [
  { code: "+1",  label: "USA / Canada (+1)" },
  { code: "+91", label: "India (+91)" },
  { code: "+44", label: "UK (+44)" },
  { code: "+61", label: "Australia (+61)" },
  { code: "+971", label: "UAE (+971)" },
  { code: "+65", label: "Singapore (+65)" },
  { code: "+49", label: "Germany (+49)" },
  { code: "+33", label: "France (+33)" },
];

export function ContactPage() {
  const [form, setForm] = useState({
    firstName: "", lastName: "", email: "", countryCode: "+1",
    phone: "", subject: "", message: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
    }, 1000);
  }

  if (submitted) {
    return (
      <section className="container" style={{ padding: "5rem 0", textAlign: "center" }}>
        <div className="card" style={{ maxWidth: "560px", margin: "0 auto" }}>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>🙏</div>
          <h1 style={{ marginBottom: "0.6rem" }}>Thank you for reaching out!</h1>
          <p style={{ color: "var(--c-ink-75)", marginBottom: "1.5rem" }}>
            We'll get back to you at <strong>{form.email}</strong> within 1–2 business days.
          </p>
          <Link to="/" className="btn btn--brand">Back to Home</Link>
        </div>
      </section>
    );
  }

  return (
    <>
      {/* Hero */}
      <section className="page-hero page-hero--brand">
        <div className="container">
          <p className="eyebrow">Get in Touch</p>
          <h1 className="display-2">Contact Us</h1>
          <p className="hero__body" style={{ maxWidth: "560px", margin: "0 auto" }}>
            We'd love to hear from you. Whether you have a question about events, donations,
            volunteering, or anything else — our team is here to help.
          </p>
        </div>
      </section>

      <section className="section" style={{ background: "var(--c-surface-alt)" }}>
        <div className="container">
          <div className="contact-layout">
            {/* Form */}
            <div className="contact-form-wrap">
              <h2 style={{ marginBottom: "1.5rem" }}>Send a Message</h2>
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="contact-form__row">
                  <div className="form-group">
                    <label className="form-label" htmlFor="firstName">First Name *</label>
                    <input
                      id="firstName"
                      name="firstName"
                      type="text"
                      className="form-input"
                      required
                      value={form.firstName}
                      onChange={handleChange}
                      placeholder="First name"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label" htmlFor="lastName">Last Name *</label>
                    <input
                      id="lastName"
                      name="lastName"
                      type="text"
                      className="form-input"
                      required
                      value={form.lastName}
                      onChange={handleChange}
                      placeholder="Last name"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="email">Email *</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    className="form-input"
                    required
                    value={form.email}
                    onChange={handleChange}
                    placeholder="your@email.com"
                  />
                </div>

                <div className="contact-form__row">
                  <div className="form-group" style={{ flex: "0 0 180px" }}>
                    <label className="form-label" htmlFor="countryCode">Country Code</label>
                    <select
                      id="countryCode"
                      name="countryCode"
                      className="form-input"
                      value={form.countryCode}
                      onChange={handleChange}
                    >
                      {COUNTRY_CODES.map((c) => (
                        <option key={c.code} value={c.code}>{c.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group" style={{ flex: 1 }}>
                    <label className="form-label" htmlFor="phone">Phone (optional)</label>
                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      className="form-input"
                      value={form.phone}
                      onChange={handleChange}
                      placeholder="Phone number"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="subject">Subject *</label>
                  <select
                    id="subject"
                    name="subject"
                    className="form-input"
                    required
                    value={form.subject}
                    onChange={handleChange}
                  >
                    <option value="">Select a subject…</option>
                    {SUBJECTS.map((s) => (
                      <option key={s} value={s}>{s}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label" htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    className="form-input"
                    required
                    rows={6}
                    value={form.message}
                    onChange={handleChange}
                    placeholder="Tell us how we can help…"
                    style={{ resize: "vertical" }}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn--brand btn--lg"
                  disabled={loading}
                  style={{ width: "100%" }}
                >
                  {loading ? "Sending…" : "Send Message"}
                </button>
              </form>
            </div>

            {/* Info sidebar */}
            <aside className="contact-info-sidebar">
              <div className="contact-info-card">
                <h3>Contact Information</h3>
                <div className="contact-info-item">
                  <span className="contact-info-item__icon">✉️</span>
                  <div>
                    <p className="contact-info-item__label">Primary Email</p>
                  <a href="mailto:hello@aekam.app" className="contact-info-item__value">
                    hello@aekam.app
                    </a>
                  </div>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-item__icon">✉️</span>
                  <div>
                    <p className="contact-info-item__label">Organization Email</p>
                  <a href="mailto:info@aekam.app" className="contact-info-item__value">
                    info@aekam.app
                    </a>
                  </div>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-item__icon">📞</span>
                  <div>
                    <p className="contact-info-item__label">Phone</p>
                    <a href="tel:+19292665742" className="contact-info-item__value">
                      929-266-5742
                    </a>
                  </div>
                </div>
                <div className="contact-info-item">
                  <span className="contact-info-item__icon">📍</span>
                  <div>
                    <p className="contact-info-item__label">Location</p>
                    <p className="contact-info-item__value">McKinney / Allen, TX area</p>
                  </div>
                </div>
              </div>

              <div className="contact-info-card" style={{ marginTop: "1.5rem" }}>
                <h3>Follow Us</h3>
                <div className="contact-social-links">
                  <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer" className="contact-social-btn">
                    <span>📘</span> Facebook
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="contact-social-btn">
                    <span>𝕏</span> Twitter / X
                  </a>
                  <a href="https://www.youtube.com" target="_blank" rel="noopener noreferrer" className="contact-social-btn">
                    <span>▶️</span> YouTube
                  </a>
                  <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer" className="contact-social-btn">
                    <span>📷</span> Instagram
                  </a>
                </div>
              </div>

              <div className="contact-info-card" style={{ marginTop: "1.5rem", background: "var(--c-brand-tint, #fef9ec)" }}>
                <p style={{ fontSize: "0.9rem", lineHeight: 1.6 }}>
                  <strong>Aekam</strong><br />
                  Community-supported spiritual platform.
                </p>
                <Link to="/donate" className="btn btn--brand btn--sm" style={{ marginTop: "0.75rem" }}>
                  Donate Now
                </Link>
              </div>
            </aside>
          </div>
        </div>
      </section>
    </>
  );
}
